module.exports = __webpack_public_path__ + "img/phone_3.041cbf7b.png";